export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "پرونده رو شرح بده يا يه سوال بپرس",
      sybmolCount: "تعداد کاراکترها باید از {min} تا {max} باشد",
      wordsCount: "تعداد کلمات باید از {min} تا {max}باشد",
      mobiledocPlaceholder: "درباره اطلاعات معاینه بیمار بیشتر به ما بگویید",
      mobiledocLabel: "داده های معاینه",
      tags: "برچسب ها",
      editCase: "ویرایش پرونده",
      anamnesisPlaceholder: "در مورد سابقه پزشکی بیمار بیشتر به ما بگویید",
      treatmentPlaceholder: "درباره درمان بیمار بیشتر بگویید",
      caseNotesPlaceholder: "درباره پرونده بیشتر به ما بگو",
      questionNotesPlaceholder: "درباره این سوال بیشتر بگویید",
      addImage: "یک تصویر را ضمیمه کنید",
      anamnesis: "آنامنسیس",
      treatment: "درمان",
      notes: "اضافه کردن",
    },
    uploader: {
      case: {
        title: "یک مورد اضافه کنید",
        description: "موارد جالب را از تمرین خود به اشتراک بگذارید",
      },
      question: {
        title: "سوال بپرسید",
        description: 'کاربران سریعتر پاسخ خواهند داد اگر "سوال"را انتخاب کنید.',
      },
    },
    title: "انجمن",
    description: "تبادل دانش میان پزشکان دربارهٔ موارد بالینی",
    all_cases: "همهٔ کیس‌ها",
    my_cases: "کیس‌های من",
    case: {
      shareLink: {
        1: "این کیس را ببینید",
        2: "در پلتفرم “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
    noCasesLang: {
      1: "هنوز هیچ مورد منتشر شده‌ای به این زبان وجود ندارد",
      2: "اولین نفر باشید که یک مطالعه DICOM را به اشتراک می‌گذارد و نظرات همکاران را دریافت می‌کند!",
    },
    filter: {
      status: {
        placeholder: "مرتب‌سازی موارد",
        values: {
          popular: "محبوب‌ترین‌ها اول",
          actual: "جدیدترین‌ها اول",
        },
        options: {
          base: "نمایش اول",
          popular: "محبوب",
          actual: "جدید",
        },
      },
      modality: {
        placeholder: "روش تصویربرداری",
      },
      bodypart: {
        placeholder: "ناحیه مورد مطالعه",
      },
      sex: {
        placeholder: "جنسیت",
        values: {
          M: "مرد",
          F: "زن",
        },
      },
    },
  },
  h1_community: "جامعه پزشکان",
};
